import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';

export default function SamplingResultsOKContent(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.container}>
            <div className={classes.headerIcon}>
                <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
            </div>
            <div className={classes.title}>{t("Results OK!")}</div>
            <div className={classes.body}>
                <div className={classes.withinTolerance}>{t("Plate within tolerances")}</div>
                <div className={classes.bodyIcon}>
                    <img className={classes.smallDone} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
                </div>
            </div>
            <div className={classes.finishTest}>
                <button className={classes.finishButton} onClick={() => props.finishTest()}>{t("FINISH TEST")}</button>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        width: "calc(100% - 150px)",
        float: "left",
        padding: "40px",
        boxSizing: "border-box",
        height: "80vh",
        position: "relative",
        top: "90px",
        left: "150px"
    },
    headerIcon: {
        width: "100%",
        textAlign: "center",
        marginTop:"50px"
    },
    done: {
        width: "60px",
        height: "60px",
        marginBottom: "15px"
    },
    smallDone: {
        width: "20px",
        height: "20px",
        marginTop: "8px"
    },
    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        textAlign: "center"
    },
    body: {
        width: "260px",
        height: "80px",
        borderRight: "1px solid #DEDEDE",
        borderLeft: "1px solid #DEDEDE",
        borderTop: "1px solid #DEDEDE",
        borderRadius: "5px",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "30px",
        backgroundColor: "#F0F0F0",
    },
    withinTolerance: {
        width: "100%",
        height: "40px",
        borderBottom: "1px solid #DEDEDE",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        textAlign: "center",
        boxSizing: "border-box",
        paddingTop: "10px"
    },
    bodyIcon: {
        textAlign: "center",
        backgroundColor: "white",
        width: "100%",
        height: "40px",
        borderBottom: "1px solid #DEDEDE",
        borderRadius: "0 0 5px 5px",
    },
    finishButton:{
        width:"120px",
        height:"40px",
        borderRadius:"5px",     
        marginTop:"50px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        fontWeight:"bold",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        border:"none",
        outline:"none",
        cursor:"pointer"
    },
    finishTest:{
        width:"100%",
        textAlign:"center"
    }
});